import "./PaperWalletPanel.scss";
import React, { useState, useEffect } from "react";
import { Card, Row, Col, Button } from "react-bootstrap";
import { getPaperWallet } from "../../actions/setting-action";
import PaperCrossTab from "./PaperCrossTab";
import PaperDepositWithdraw from "./PaperDepositWithdraw";
import PaperIsolatedTab from "./PaperIsolatedTab";
import PaperSpotTab from "./PaperSpotTab";
import PaperTransferModal from "./PaperTransferModal";
import { connect, useSelector } from "react-redux";

import { AccountName, AccountType } from "../../Const";
import { useTranslation } from "react-i18next";
const tabTitles = [AccountName.us_equity,AccountName.forex,AccountName.indice,AccountName.metal];
const tabTypes = [AccountType.us_equity,AccountType.forex,AccountType.indice,AccountType.metal];
const PaperWalletPanel = (props) => {
  const {t} = useTranslation()
  const { getPaperWallet } = props;
  const [activeTab, setActiveTab] = useState(0);
  const [showDeposit, setShowDeposit] = useState(false);
  const [isDeposit, setIsDeposit] = useState(true);
  const [showTransfer, setShowTransfer] = useState(false);
  const {
    usEquityCoins,
    indiceCoins,
    forexCoins,
    metalCoins,
    totalSpot,
    totalCross,
    totalIsolated,
  } = useSelector((state) => state.settings.paperWallet) || {};

  const total = (totalSpot || 0) + (totalCross || 0) + (totalIsolated || 0);
  useEffect(() => {
    tabTypes.forEach((el) => {
      getPaperWallet(el).then(console.log);
    });
  }, []);

  useEffect(() => {
    console.log("herer");
    getPaperWallet(tabTypes[activeTab]).then(console.log);
  }, []);

  const tabHeaders = tabTitles.map((item, index) => {
    return (
      <Col xs={4} xl={2} key={index}>
        <a
          onClick={() => setActiveTab(index)}
          className={index == activeTab ? "tab-active" : "tab-inactive"}
        >
          {item}
        </a>
      </Col>
    );
  });
  const walletTabs = [
    <PaperSpotTab coins={usEquityCoins} totalSpot={totalSpot} />,
    <PaperSpotTab coins={forexCoins} totalSpot={totalSpot} />,
    <PaperSpotTab coins={indiceCoins} totalSpot={totalSpot} />,
    <PaperSpotTab coins={metalCoins} totalSpot={totalSpot} />
  ];
  const clickDeposit = () => {
    setShowDeposit(true);
    setIsDeposit(true);
  };
  const clickWithdraw = () => {
    setShowDeposit(true);
    setIsDeposit(false);
  };
  return (
    <div className="paper-wallet round-bg">
      <div>
        <h5>Paper Wallet</h5>
        <Row noGutters className="total-row">
          <Col>
            <div className="title">{t("tb")}</div>
            <div className="value">{total.toFixed(6)} USD</div>
          </Col>
          <Col className="btn-col">
            <Button variant="outline-primary" onClick={clickDeposit}>
              {t("ADD")}
            </Button>
          </Col>
          <Col className="btn-col">
            <Button variant="outline-primary" onClick={clickWithdraw}>
            {t("REDUCE")}
            </Button>
          </Col>
          {/* <Col className="btn-col">
            <Button
              variant="outline-primary"
              onClick={() => setShowTransfer(true)}
            >
              {t("TRANSFER")}
            </Button>
          </Col> */}
        </Row>
        <hr />
        <Row noGutters className="my-4">
          {tabHeaders}
        </Row>
        {walletTabs[activeTab]}
      </div>
      {usEquityCoins && <PaperDepositWithdraw
        show={showDeposit}
        onHide={() => setShowDeposit(false)}
        isDeposit={isDeposit}
        setIsDeposit={setIsDeposit}
        t={t}
      /> }
      <PaperTransferModal show={showTransfer} onHide={setShowTransfer} />
    </div>
  );
};

export default connect(null, { getPaperWallet })(PaperWalletPanel);
